<div class="main_body">
  <app-page-header
    title="データ利用量"
    i18n-title="@@adminSystem.monthlySummaries.title.page"
    subtitle="一か月のデータ使用量を確認します"
    i18n-subtitle="@@adminSystem.monthlySummaries.label.description"
    icon="storage"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- Month Navigation -->
          <div class="month-nav">
            <a mat-icon-button
               [routerLink]="getRouterLink(basePath, yearOfPrevMonth, monthOfPrevMonth)"
               matTooltip="前月" aria-label="前月">
              <mat-icon>chevron_left</mat-icon>
            </a>
            <span class="month-nav__prev">{{yearOfPrevMonth}}/{{monthOfPrevMonth}}</span>
            <span class="month-nav__current">
              {{year}}年{{month}}月
              <span class="month-nav__label" i18n="@@adminSystem.monthlySummaries.label.monthlyUsage">月間データ使用量</span>
              <span class="month-nav__status">({{fixed}})</span>
            </span>
            <span class="month-nav__next">{{yearOfNextMonth}}/{{monthOfNextMonth}}</span>
            <a mat-icon-button
               [routerLink]="getRouterLink(basePath, yearOfNextMonth, monthOfNextMonth)"
               matTooltip="翌月" aria-label="翌月">
              <mat-icon>chevron_right</mat-icon>
            </a>
          </div>
          <!-- Right: Actions -->
          <div class="table-toolbar__actions">
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSystem.monthlySummaries.tooltip.refresh"
              i18n-aria-label="@@adminSystem.monthlySummaries.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <!-- Skeleton Loading -->
            <div class="skeleton-table">
              @for (row of [1, 2, 3, 4, 5]; track row) {
                <div class="skeleton-table__row">
                  <div class="skeleton skeleton--name"></div>
                  <div class="skeleton skeleton--usage"></div>
                  <div class="skeleton skeleton--quota"></div>
                  <div class="skeleton skeleton--rest"></div>
                </div>
              }
            </div>
          } @else {
            <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="status" matSortDirection="desc">

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 200px;" i18n="@@adminSystem.monthlySummaries.table.name"> セクショングループ・セクション名 </th>
                <td mat-cell *matCellDef="let row" [style.padding-left]="row.type == 'sectionGroup' ? '20px' : '60px'">
                  @if(row.type == "sectionGroup"){
                    {{row.sectionGroupName}}
                  }
                  @else{
                    {{row.sectionName}}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="dataUsage">
                <th mat-header-cell *matHeaderCellDef style="min-width: 90px;" i18n="@@adminSystem.monthlySummaries.table.dataUsage"> 使用データ量 </th>
                <td mat-cell *matCellDef="let row">
                  @if(row.type == "sectionGroup"){
                    {{row.dataUsedSharedGB.toFixed(2)}} / {{row.monthlyQuotaGB.toFixed(0)}} GB
                  }
                  @else{
                    {{row.dataUsedGB.toFixed(2)}}GB
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="quotaModel">
                <th mat-header-cell *matHeaderCellDef style="min-width: 90px;" i18n="@@adminSystem.monthlySummaries.table.quotaModel"> 月間使用量上限 </th>
                <td mat-cell *matCellDef="let row">
                  @if(row.type == "section"){
                    {{row.monthlyQuotaDesc}}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSystem.monthlySummaries.table.status">データ使用状況</th>
                <td mat-cell *matCellDef="let row" class="usage-status-cell">
                  <mat-icon [class.ok]="row.usageStatus !== '超過'" [class.warning]="row.usageStatus === '超過'">
                    {{ row.usageStatus === '超過' ? 'cloud_alert' : 'check_circle' }}
                  </mat-icon>
                  {{ row.usageStatus }}
                </td>
              </ng-container>

              <ng-container matColumnDef="numOfStaffs">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSystem.monthlySummaries.table.numOfStaffs">スタッフ数</th>
                <td mat-cell *matCellDef="let row">
                  {{row.numOfStaffs}}
                </td>
              </ng-container>

              <ng-container matColumnDef="numOfContributors">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSystem.monthlySummaries.table.numOfContributors">多職種スタッフ数</th>
                <td mat-cell *matCellDef="let row">
                  {{row.numOfContributors}}
                </td>
              </ng-container>

              <ng-container matColumnDef="numOfUsers">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSystem.monthlySummaries.table.numOfUsers">ユーザー数</th>
                <td mat-cell *matCellDef="let row">
                  {{row.numOfUsers}}
                </td>
              </ng-container>

              <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;"> </th>
                <td mat-cell *matCellDef="let row" (click)="expandCollapse(row)">
                  @if(row.type == "sectionGroup"){
                    <mat-icon>{{ row.disp ? 'expand_less' : 'expand_more' }}</mat-icon>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns" [style.filter]="row.type =='section' ? 'brightness(0.9)' : ''"></tr>
            </table>
          }
        </div>
      </section>
    </div>
  </div>
</div>
